class LevayoReviewPhotos extends HTMLElement {
  connectedCallback() {
    if (this.ready) return;
    this.ready = true;
    const buttons = [...this.querySelectorAll('[data-full]')];
    const dialog = this.querySelector('dialog');
    const image = dialog.querySelector('img');
    let index = 0;
    let opener;
    const show = (next) => {
      index = (next + buttons.length) % buttons.length;
      image.src = buttons[index].dataset.full;
      image.alt = buttons[index].querySelector('img').alt;
      dialog.querySelector('[data-counter]').textContent = `${index + 1} / ${buttons.length}`;
    };
    buttons.forEach((button, i) => button.addEventListener('click', () => {
      opener = button; show(i); dialog.showModal();
    }));
    dialog.querySelector('[data-close]').addEventListener('click', () => dialog.close());
    dialog.querySelector('[data-prev]').addEventListener('click', () => show(index - 1));
    dialog.querySelector('[data-next]').addEventListener('click', () => show(index + 1));
    if (buttons.length < 2) dialog.querySelectorAll('[data-prev],[data-next]').forEach(b => b.hidden = true);
    dialog.addEventListener('keydown', event => {
      if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') {
        event.preventDefault(); show(index + (event.key === 'ArrowRight' ? 1 : -1));
      }
    });
    dialog.addEventListener('click', event => {
      if (event.target !== dialog) return;
      const r = dialog.getBoundingClientRect();
      if (event.clientX < r.left || event.clientX > r.right || event.clientY < r.top || event.clientY > r.bottom) dialog.close();
    });
    dialog.addEventListener('close', () => opener?.focus());
  }
}
if (!customElements.get('levayo-review-photos')) customElements.define('levayo-review-photos', LevayoReviewPhotos);
